import { Steps, Text } from "@/atoms"
import { Trans, useTranslation } from "@/hooks/useTranslation"

import styles from "./AzurePatSteps.module.scss"

import type { AzurePatStepsProps } from "./AzurePatSteps.types"

export const AzurePatSteps = ({
  instructions,
  scopes,
  note,
  children
}: AzurePatStepsProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.connect.azure.steps"
  })
  const status = "process"

  return (
    <Steps
      className={styles.steps}
      size="small"
      orientation="vertical"
      items={[
        {
          status,
          title: t("generate.title"),
          content: (
            <>
              <Text type="secondary">{t("generate.description")}</Text>
              <ol className={styles.list}>
                {instructions.map((instruction) => (
                  <li key={instruction}>
                    <Text>
                      <Trans>{instruction}</Trans>
                    </Text>
                  </li>
                ))}
                <li>
                  <Text>
                    <Trans>{t("generate.6.title")}</Trans>
                    <ul className={styles.nestedList}>
                      {scopes.map((scope) => (
                        <li key={scope}>
                          <Text>
                            <Trans>{scope}</Trans>
                          </Text>
                        </li>
                      ))}
                    </ul>
                  </Text>
                </li>
              </ol>
              {note && <Text type="secondary">{note}</Text>}
            </>
          )
        },
        { status, title: t("accessToken.title"), content: children }
      ]}
    />
  )
}
